import SelectComponents from "src/components/SelectComponents";

import { useHeaderSearchRecentsContext } from "./HeaderSearchRecentsContext";
import { isBlankHeaderSearchTerm } from "./headerSearchRecentEntries";

type HeaderSearchInputProps = {
  selectProps: {
    headerSearchTerm?: string | null;
    menuIsOpen?: boolean;
    maxLength?: number;
  };
  "aria-activedescendant"?: string;
  "aria-controls"?: string;
};

/**
 * react-select writes combobox aria onto its input from an internal allowlist
 * and drops aria-activedescendant / aria-controls passed to Select. Override
 * them here so the real input points at the recents listbox.
 */
const HeaderSearchInput = (props: HeaderSearchInputProps) => {
  const api = useHeaderSearchRecentsContext();
  const recentsVisible = Boolean(
    api &&
    !api.loading &&
    api.targets.length > 0 &&
    isBlankHeaderSearchTerm(props.selectProps.headerSearchTerm) &&
    props.selectProps.menuIsOpen
  );

  if (!recentsVisible || !api) {
    return <SelectComponents.Input {...props} />;
  }

  return (
    <SelectComponents.Input
      {...props}
      aria-controls="header-search-recents"
      aria-activedescendant={api.activeOptionId}
    />
  );
};

export default HeaderSearchInput;
